module.exports = __webpack_public_path__ + "img/point_bronze.ed14538c.svg";